export default {"src":"/_next/static/media/house-solid-full.f3dbd57d.svg","height":640,"width":640,"blurWidth":0,"blurHeight":0};